<template>
    <div class="inPage">
        <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
        <router-view @sendBanner="updateBanner"></router-view>
        
    </div>
</template>

<script>
import BannerIn from '../../components/BannerIn/BannerIn'
export default {
    components:{
        BannerIn,
    },
    data() {
        return {
            bannerUrl:'',
            positionInfo:{},
            
        };
    },
   
    mounted() {
        
    },
    methods: {
        updateBanner(data){
            this.bannerUrl = data.bannerUrl;
            this.positionInfo = data.positionInfo;
        }
    },
};
</script>

<style lang="scss" scoped>


</style>


// WEBPACK FOOTER //
// src/pages/Other/Other.vue